import Vue from 'vue'
import Vuex from 'vuex'
import * as types from './mutation-types'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

const storagePlugin = store => {
  let saved_data = JSON.parse(window.sessionStorage.cartData || '{}');
  let new_state = {};
  for (var k in store.state) {
    new_state[k] = saved_data[k] || store.state[k];
  }
  store.replaceState(new_state);

  store.subscribe((mutation, state) => {
    try {
      window.sessionStorage.cartData = JSON.stringify(state);
    } catch (e) {
      // i hate you safari
    }
  })
}

function optionKey(item) {
    return `${item.id}#${item.option.toLowerCase().replace(/ /g, '-')}`
}

export default new Vuex.Store({
  strict: debug,
  plugins: [storagePlugin],
  state: {
    cart: {},
    date_selected: {},
    item_ids: [],
    total: 0,
  },
  getters: {
    cart: state => state.cart,
    date_selected: state => state.date_selected,
    item_ids: state => Object.keys(state.cart),
    hot_food: state => {
      for (let k in state.cart) {
        let item = state.cart[k]
        if (item.hot) {
          return true
        }
      }
      return false
    },
    total: state => {
      return Object.values(state.cart)
        .map(item => item.price * item.qty)
        .reduce((sum, value) => {
          return sum + value
        }, 0)
    },
  },
  actions: {
    setCart ({commit, getters}, data) {
      commit(types.CART, data)
    },
    setSchedule({commit}, data) {
      commit(types.CALENDAR, data)
    },
    addItem ({commit, getters}, item) {
      commit(types.ADD_ITEM, item)
    },
    removeItem ({commit, gettings}, item) {
      commit(types.REMOVE_ITEM, item)
    },
    changeQty ({commit, gettings}, item, qty) {
      commit(types.CHANGE_QTY, item, qty)
    },
  },
  mutations: {
    [types.CART] (state, data) {
      state.cart = data
    },
    [types.CALENDAR] (state, data) {
      state.date_selected = data
    },
    [types.ADD_ITEM] (state, item) {
      let key = optionKey(item)

      if (state.cart[key] === undefined) {
        let data = Object.assign({}, item)

        let m = /minimum of (\d+)/.exec(data.option)

        if (!m) {
          data.qty = 1
        }
        else {
          let minqty = Number(m[1])

          if (minqty && !isNaN(minqty)) {
            data.qty = minqty
          }
          else {
            data.qty = 1
          }
        }

        Vue.set(state.cart, key, data)
      }
      else {
        state.cart[key].qty++
      }
    },
    [types.REMOVE_ITEM] (state, item) {
      let key = optionKey(item)

      if (state.cart[key] !== undefined) {
        Vue.delete(state.cart, key)
      }
    },
    [types.CHANGE_QTY] (state, {item, qty}) {
      let key = optionKey(item)

      if (state.cart[key] !== undefined) {
        state.cart[key].qty = qty
      }
    },
  }
})
